import { ArrowRight } from 'lucide-react';
import type { Staff } from '../content/types';
import { pictureOf } from '../content/images';
import { roleName } from '../content';

/** The learner, as a speaker. */
export const YOU = { cast: 'you', name: 'You' } as const;

/** A person's face in a small circle; the first letter of their role while there's no picture. */
export function Avatar({ cast, name, size = 32, active = false }: { cast: string | null; name: string; size?: number; active?: boolean }) {
  const face = cast ? pictureOf(`face-${cast}`) : null;
  return (
    <span className="avatar" data-who={cast ?? 'other'} data-active={active || undefined} style={{ width: size, height: size }} aria-hidden="true">
      {face ? <img src={face.small} alt="" width={size} height={size} draggable={false} /> : <span>{name[0]}</span>}
    </span>
  );
}

/**
 * Who speaks to whom: two faces and an arrow, read out as words ("You speak to the shopkeeper").
 * It is the only cue to the speaker for a phrase without a picture.
 */
export function RoleChip({ staff, from }: { staff: Staff; from: 'you' | 'staff' }) {
  const them = { cast: staff.cast, name: staff.role };
  const [a, b] = from === 'you' ? [YOU, them] : [them, YOU];
  return (
    <span className="role-chip">
      <Avatar cast={a.cast} name={a.name} size={24} />
      <ArrowRight size={14} aria-hidden="true" />
      <Avatar cast={b.cast} name={b.name} size={24} />
      <span className="sr-only">{from === 'you' ? `You speak to the ${roleName(staff)}` : `The ${roleName(staff)} speaks to you`}</span>
    </span>
  );
}
